import React, { Component } from "react";
import ReactTable from "react-table-6";
import "react-table-6/react-table.css";

import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from "@syncfusion/ej2-react-popups";
import Loader from "react-loader-spinner";
import Select from "react-select";

class WebsiteReading extends Component {
  constructor() {
    super();
    this.dialogClose = () => {
      this.setState({
        hideDeletePopup: false,
        hideDeleteAllPopup: false,
        hideIncorrectPassword: false,
      });
    };

    this.hideConfirmRootUrl = () => {
      this.setState({
        isRootUrl: false,
        showRootUrlConfirm: false,
      });
      this.refreshData();
    };
    this.DeletedialogClose = () => {
      this.setState({ hideTextAreaPopup: false });
    };
    this.IncorrectPassworddialogClose = () => {
      this.setState({ hideIncorrectPassword: false });
    };

    this.settings = {
      effect: "Zoom",
      duration: 400,
      delay: 0,
      position: "center",
    };

    this.rootUrlConfirmButtons = [
      {
        buttonModel: {
          content: "Ok",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: (props) => {
          this.refreshData();
          this.setState({ isRootUrl: false, showRootUrlConfirm: false });
        },
      },
    ];

    

    //for delete dialog component ok click
    this.buttons = [
      {
        buttonModel: {
          content: "Yes",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: (props) => {
          this.deleteProjectWebsiteApi(this.state.propsId);
          this.setState({ disabled: false });
        },
      },
      {
        buttonModel: {
          content: "No",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: () => {
          this.setState({
            hideDeletePopup: false,
            disabled: false,
          });
        },
      },
    ];

    //deleteall
    this.deleteAllButton = [
      {
        buttonModel: {
          content: "Yes",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: () => {
          this.setState({
            hideDeleteAllPopup: false,
            hideTextAreaPopup: true,
          });
        },
      },
      {
        buttonModel: {
          content: "No",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: () => {
          this.setState({
            hideDeleteAllPopup: false,
            hideTextAreaPopup: false,
          });
        },
      },
    ];

    //deleteall
    this.textAreaConfir = [
      {
        buttonModel: {
          content: "Yes",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: () => {
          this.deleteInputValidation();
        },
      },
      {
        buttonModel: {
          content: "No",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: () => {
          this.setState({
            hideTextAreaPopup: false,
          });
        },
      },
    ];
    //incorrectPasswordButtons
    this.incorrectPasswordButtons = [
      {
        buttonModel: {
          content: "Ok",
          cssClass: "e-flat",
          isPrimary: true,
        },
        click: () => {
          this.setState({
            hideTextAreaPopup: true,
            hideIncorrectPassword: false,
          });
        },
      },
    ];

    this.state = {
      isRootUrl: false,
      showRootUrlConfirm: false,
      confirmMsg: "",
      inEditState: false,
      showClearButton: false,
      showClearButtonOnclick: false,
      hideDeleteAllPopup: false,
      hideIncorrectPassword: false,
      data: [
        {
          id: "",
          question: "",
          originalQuestionId: "",
          autoTranslate: "",
          alias: "",
        },
      ],
      pageNum: null,
      disabled: false,
      editedId: "-1",
      editImageSrc: "./assets/images/edit2.png",
      hidden: false,
      hideAddDialog: false,
      hideupdateDialog: false,
      hideDeletePopup: false,
      hideDeleteSuccessPopup: false,
      successResp: false,
      hideTextAreaPopup: false,
      urlList: [],
      contentCount: 0
    };
    this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    this.editImageSrc = "./assets/images/edit2.png";
    this.deleteRootUrlMsg = "The root URL has been deleted. The crawled URLs from the same will be deleted in a few seconds.",
      this.saveRootUrlMsg = "The root URL has been successfully added. Content from the crawled URLs will be added in a few seconds."
  }

  notifyFailedToLoad() {
    toast.dismiss();
    toast(
      <b style={{ color: "red" }}>Oops! Error occurred.Please try again</b>,
      {
        position: "top-center",
        color: "red",
      }
    );
  }

  addProjectWesite = (data) => {
    var thisController = this;
    if (thisController.state.pageNum != 0) {
      thisController.setState({ pageNum: 0 });
    }
    this.state.data.unshift({
      id: "",
      question: "",
      autoTranslate: "",
    });
    this.setState({
      data: this.state.data,
      disabled: true,
    });
  };
  deleteInputValidation = () => {
    if (
      document.getElementById("deleteInputFromUser").value == "Delete" ||
      document.getElementById("deleteInputFromUser").value == "delete" ||
      document.getElementById("deleteInputFromUser").value == "DELETE"
    ) {
      document.getElementById("deleteInputFromUser").value = "";
      this.deleteAllProjectWebsiteApi();
    } else {
      this.setState({
        hideIncorrectPassword: true,
      });
    }
  };

  saveProjectWebsiteApi = (props, e) => {
    this.state.data[props.index].url = document
      .getElementById("url" + props.index)
      .innerText.trim();

    this.state.editedId = "-1";
    this.setState(this.state);

    let url = props.original.url;
    if (!url.startsWith("http://") && !url.startsWith("https://")) {
      url = "https://" + url;
    }
    var validateResult = this.validateUrl(url);

    if (this.state.urlList.includes(url)) {
      this.notifyDuplicateURL();

    } else if (this.state.contentCount >= 500) {
      this.notifyExceededContentLimit();

    } else {
      if (validateResult == true) {
        var thisController = this;
        $.ajax({
          url: "/api/project-website",
          async: false,
          method: "POST",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
          },
          data: {
            projectId: localStorage.getItem("currentProjectId"),
            url: url,
          },
          success: function (res) {
            if (res.success === true) {
              //   thisController.notifyAdd();
              thisController.state.disabled = false;
              thisController.setState({ showRootUrlConfirm: true, confirmMsg: thisController.saveRootUrlMsg });
              thisController.fetchProjectWebsiteApi();
            } else {
              thisController.notifyFailedToAdd(res.result);
              thisController.state.disabled = false;
            }
          },
          error: function (xhr) {
            if (xhr.status == 401) {
              window.location.href = "/";
            }
          },
        });
      }
    }
  };

  notifyAdd() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Project Website Added Successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyFailedToAdd(response) {
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red",
    });
  }

  makeCelleditable(props, e) {
    this.markAsBeingEdited(this.state.data[props.index].id);
  }
  markAsBeingEdited(id) {
    this.state.inEditState = true;
    this.state.editedId = id;
    var stateObj = this.state;
    this.setState(stateObj);
  }

  updateProjectWebsiteApi(props, e) {
    this.state.data[props.index].url = document
      .getElementById("url" + props.index)
      .innerText.trim();

    let url = this.state.data[props.index].url;
    if (!url.startsWith("http://") && !url.startsWith("https://")) {
      url = "https://" + url;
    }
    var validateResult = this.validateUrl(url);
    if (this.state.urlList.includes(url)) {
      this.notifyDuplicateURL();
    } else {
      if (validateResult == true) {
        var updatedData = {
          url: url,
          projectWebsiteId: this.state.data[props.index].id,
        };
        var thisController = this;
        $.ajax({
          url: "/api/project-website-update",
          async: false,
          method: "POST",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
          },
          data: updatedData,
          success: function (res) {
            if (res.success === true) {
              thisController.state.editedId = "-1";
              thisController.notifyUpdate();
              thisController.fetchProjectWebsiteApi();
            } else {
              thisController.notifyFailedToUpdate(res.result);
            }
          },
          error: function (xhr) {
            if (xhr.status == 401) {
              window.location.href = "/";
            }
          },
        });
      }
    }
  }

  notifyUpdate() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Project Website Updated Successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyFailedToUpdate(response) {
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red",
    });
  }

  validateUrl(url) {
    if (url == "") {
      this.notifyMsgFieldEmpty();
    } else {
      const urlRegex =
        /^(https?:\/\/)?(www\.)?([\da-z.-]+)\.([a-z.]{2,})(\/[\w.-]*)*\/?$/;
      if (urlRegex.test(url)) {
        return true;
      } else {
        this.notifyInvalidURL();
      }
    }
    return false;
  }

  notifyMsgFieldEmpty() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please fill all the fields
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyInvalidURL() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please provide a proper URL
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyDuplicateURL() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;This URL has been already added
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyExceededContentLimit() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;The content limit has already crossed!
      </b>,
      {
        position: "top-center",
      }
    );
  }

  deleteProjectWebsiteApi = (id) => {
    let deleteRowViewController = this.state.data;
    let deleteApiViewController = this;
    var deleteConstructorVariables = this;

    if (id == "") {
      deleteApiViewController.setState({ deleteRow: true });
      deleteConstructorVariables.setState({ hideDeletePopup: false });
      deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
      deleteRowViewController.splice(id, 1);
      deleteRowViewController.loadData();
    }
    $.ajax({
      url: "/api/project-website/" + id,
      async: false,
      method: "DELETE",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          if (deleteConstructorVariables.state.isRootUrl) {
            deleteConstructorVariables.setState({ showRootUrlConfirm: true, confirmMsg: deleteConstructorVariables.deleteRootUrlMsg });
          } else {
            deleteConstructorVariables.notifyDeleted();
          }
          deleteApiViewController.setState({
            deleteRow: true,
            hideDeletePopup: false,
          });
          deleteRowViewController.splice(id, 1);

          deleteConstructorVariables.fetchProjectWebsiteApi();
        } else {
          deleteConstructorVariables.notifyFailedToDelete(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      },
    });
  };

  notifyDeleted(message) {
    toast.dismiss();
    let defaultMessage = "Project Website Deleted Successfully";
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp; {message ? message : defaultMessage}
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyFailedToDelete(response) {
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red",
    });
  }

  //---------------Delete all------------------------//
  deleteAllProjectWebsiteApi = () => {
    // TODO: Change the implementaion
    /* let thisController = this;
        $.ajax({
            url: "/api/faqQuestions/delete/all",
            async: false,
            method: 'POST',
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            data: {
                projectId: localStorage.getItem('currentProjectId'),
            },
            success: function (res) {

                if (res.success === true && res.result === "done.") {
                    thisController.state.hideTextAreaPopup = false;
                    thisController.state.checkBoxRows = [];
                    thisController.setState(thisController.state);
                    thisController.fetchFaqDataApi();
                    thisController.notifyDeleteAllSuccess();
                } else if (res.success === true && res.result != "done.") {

                    thisController.notifyNodata(res.result);
                }


                else {
                    thisController.notifyFailedToDelete(res.result);
                }
            },

            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }

        }); */
  };

  notifyFailedToDelete(response) {
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red",
    });
  }

  notifyNodata(response) {
    this.setState({
      hideTextAreaPopup: false,
    });
    toast.dismiss();
    toast(<b>{response}</b>, {
      position: "top-center",
      color: "red",
    });
  }
  notifyDeleteAllSuccess() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;All Project Websites have been deleted Successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }
  refreshData = (id) => {
    var refreshContent = this;
    refreshContent = this.state.editedId = id;
    this.fetchProjectWebsiteApi();
    this.setState({ disabled: false });
  };

  fetchProjectWebsiteApi = (projectId) => {
    var thisController = this;
    thisController.state.successResp = false;
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem("currentProjectId");
      }
    }
    $.ajax({
      url: "/api/project-website",
      async: false,
      method: "GET",
      data: {
        projectId: projectId,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          thisController.state.inEditState = false;
          let messages = res.result.projectWebsiteList;
          let contentCount = res.result.projectContentCount;
          thisController.setState({
            data: messages,
            successResp: true,
            disabled: false,
            urlList: messages.map((message) => message.url),
            contentCount: contentCount
          });
        } else {
          thisController.notifyFailedToLoad();
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      },
    });
  };

  pushToContentPage = (props, e) => {
    this.props.history.push({
      pathname: "/projectmgmt/content-details",
      state: {
        projectWebsiteId: props.original.id,
      },
    });
  };

  componentDidMount() {
    setTimeout(() => {
      this.fetchProjectWebsiteApi();
    }, 300);

    if (this.props.location.state != undefined) {
      this.setState({ pageNum: this.props.location.state.pageNum });
    }

    var thisController = this;
    document.addEventListener("projectChanged", function (event) {
      thisController.projectId = event.projectId;
      thisController.fetchProjectWebsiteApi(event.projectId);
      thisController.state.disabled = false;
    });
  }

  onPageChange = (e) => {
    this.setState({ pageNum: e });
  };

  render() {
    const { data } = this.state;
    const columns = [
      {
        Header: "Dno",
        accessor: "id",
        show: false,
        Cell: (props) => (
          <div name="id" id={"id" + props.index}>
            {props.original.id}
          </div>
        ),
      },
      {
        Header: () => <b>URL</b>,
        accessor: "url",
        sortable: false,
        Cell: (props) => (
          <div name="url">
            <div
              className="textarea"
              type="text"
              style={{
                background: "white",
                height: "2.7em",
                resize: "none",
                width: "98%",
                paddingLeft: "2px",
                paddingTop: "6px",
                border:
                  props.original.id == "" ||
                    props.original.id == this.state.editedId
                    ? "1px solid #D2D4DC"
                    : "none",
                borderRadius: props.original.id == "" ? "2px" : "none",
              }}
              id={"url" + props.index}
              rows="1"
              maxlength="250"
              contentEditable={
                !(props.original.id == ""
                  ? false
                  : props.original.id != this.state.editedId)
                  ? "plaintext-only"
                  : false
              }
            >
              {props.original.url}
            </div>
          </div>
        ),
      },
      {
        Header: () => <b>Is Root URL</b>,
        accessor: "rootWebsiteId",
        width: 150,
        overflow: "visible",
        sortable: false,
        Cell: (props) => (
          <div name="isRootUrl">
            {" "}
            {props.original.rootWebsiteId == null && (
              <img
                className="img-responsive"
                style={{
                  width: "2rem",
                  height: "2rem",
                }}
                src="./assets/images/check-mark.png"
              />
            )}
          </div>
        ),
      },
      {
        Header: <b> Action </b>,
        accessor: "action",
        width: 150,
        overflow: "visible",
        sortable: false,
        Cell: (props) => (
          <div id="action">
            <div>
              {/* content Link */}
              <button
                style={{
                  backgroundColor: "#ffffff",
                  border: "none",
                  marginTop: "-13px",
                }}
                hidden={props.original.id == "" ? true : false}
                onClick={(e) => {
                  this.pushToContentPage(props, e);
                }}
              >
                <img
                  className="img-responsive"
                  style={{
                    width: "2rem",
                    height: "2rem",
                    marginTop: "10px",
                    backgroundColor: "#282a65",
                    borderRadius: "5px",
                    padding: "1px",
                  }}
                  title="Content"
                  src="./assets/images/content.png"
                />
              </button>
              {/* save button */}
              {props.original.id === "" && (
                <button
                  style={{
                    backgroundColor: "#ffffff",

                    border: "none",
                    marginTop: "-13px",
                  }}
                >
                  <img
                    className="img-responsive"
                    style={{
                      marginTop: "8px",
                      backgroundColor: "#282a65",
                      borderRadius: "5px",
                      padding: "1px",
                    }}
                    title="Save"
                    src={this.saveImageSrc}
                    onClick={(e) => {
                      this.saveProjectWebsiteApi(props, e);
                    }}
                  />
                </button>
              )}

              <button
                style={{
                  backgroundColor: "#ffffff",
                  border: "none",
                  marginTop: "-9px",
                  marginLeft: "-6px",
                }}
                title="Delete"
              >
                <img
                  className="img-responsive"
                  style={{
                    marginTop: "6px",

                    backgroundColor: "#282a65",
                    borderRadius: "5px",
                    padding: "1px",
                  }}
                  src={"./assets/images/baseline_delete_white_24dp.png"}
                  onClick={() =>
                    props.original.id === ""
                      ? this.fetchProjectWebsiteApi()
                      : this.setState({
                        hideDeletePopup: true,
                        deletePropIndex: props.index,
                        propsId: props.original.id,
                        isRootUrl: props.original.rootWebsiteId == null,
                      })
                  }
                />
              </button>
            </div>
          </div>
        ),
      },
    ];
    return (
      <div>
        <Loader
          type="TailSpin"
          color="#282a65"
          visible={this.state.successResp ? false : true}
          height={300}
          width={50}
          style={{ textAlign: "center" }}
        />
        <div style={{ display: this.state.successResp ? "block" : "none" }}>
          <div style={{ background: "#F9F9FB" }}>
            {/* for toaster */}
            <link rel="stylesheet" href="assets/css/ReactToastify.css" />
            {/* for reactTable */}
            <link
              rel="stylesheet"
              href="assets/css/React_Table_CSS/react-table.css"
            />

            {/*for dialog component */}
            <link href="assets/css/ej2-base.css" rel="stylesheet" />
            <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
            <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
            <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
            <link href="assets/css/screenResolution.css" rel="stylesheet" />

            {/* Font Awesome Icons */}
            <link
              rel="stylesheet"
              href="plugins/font-awesome/css/font-awesome.min.css"
            />
            {/* IonIcons */}
            <link
              rel="stylesheet"
              href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css"
            />
            <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
            {/* Theme style */}
            <link rel="stylesheet" href="assets/css/adminlte.css" />
            <link rel="stylesheet" href="assets/css/styles.css" />
            <link rel="stylesheet" href="assets/css/custom-style.css" />
            {/* Select2 */}
            <link rel="stylesheet" href="plugins/select2/select2.min.css" />
            <link rel="stylesheet" href="assets/css/toggleButton.css" />
            <link rel="stylesheet" href="./assets/css/react-table-height.css" />

            <div className="content-header">
              <div className="container-fluid">
                <div
                  className="row"
                  style={{ alignItems: "center", justifyContent: "flex-start" }}
                >
                  <div className="col-sm-6">
                    <h1 className="m-0 page-title">Website reading</h1>
                    <h6 className="taglineTxt">
                      Provide web content for your agent
                    </h6>
                  </div>
                  <div
                    className="d-flex flex-row-reverse pt-2 col-sm-2"
                    align="right"
                    style={{ marginLeft: "30rem" }}
                  >
                    <button
                      title="Refresh"
                      onClick={this.refreshData}
                      type="button"
                      className="btn action-button"
                      style={{ marginLeft: "1rem" }}
                    >
                      <img src="./assets/images/refresh_white_24dp.png"></img>
                    </button>
                    <button
                      className="btn action-button "
                      title="Add"
                      id="addMsg"
                      style={{ marginRight: "-2px" }}
                      onClick={
                        this.state.disabled
                          ? this.notifyMsgFieldEmpty
                          : this.addProjectWesite
                      }
                    >
                      <img src="assets/images/add_white_24dp.png" />
                    </button>
                  </div>
                </div>
              </div>
              {/* left Menu start here*/}
              {/* Content Header (Page header) */}
              {/* /.content-header */}
              {/* Custom Tabs */}
              <div className="content">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-lg-12 ">
                      <div className="card">
                        <ReactTable
                          data={data}
                          columns={columns}
                          defaultPageSize={10}
                          pageSizeOptions={[5, 10, 15]}
                          onPageChange={this.onPageChange}
                          page={this.state.pageNum}
                        />
                      </div>
                      <ToastContainer className="Toast-at-center" />

                      {/*Dialog Component For Deletion Confirmation*/}
                      <DialogComponent
                        width="400px"
                        animationSettings={this.settings}
                        header="Delete Project Website"
                        showCloseIcon={true}
                        buttons={this.buttons}
                        ref={(dialog) => (this.dialogInstance = dialog)}
                        visible={this.state.hideDeletePopup}
                        close={this.dialogClose}
                      >
                        <img
                          src="assets/images/warn.svg"
                          style={{
                            paddingRight: "0px",
                            height: "20px",
                            width: "20px",
                          }}
                          content=""
                        />
                        &nbsp;Do you want to delete this project website? Note:
                        Press 'Yes' to delete or press 'No' to decline.
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      </DialogComponent>

                      <DialogComponent
                        width="400px"
                        animationSettings={this.settings}
                        header="Confirm"
                        showCloseIcon={true}
                        buttons={this.rootUrlConfirmButtons}
                        ref={(dialog) => (this.dialogInstance = dialog)}
                        visible={this.state.showRootUrlConfirm}
                        close={this.hideConfirmRootUrl}
                      >
                        <img
                          src="assets/images/done.svg"
                          style={{
                            paddingRight: "0px",
                            height: "20px",
                            width: "20px",
                          }}
                          content=""
                        />
                        &nbsp;{this.state.confirmMsg}
                      </DialogComponent>




                      {/*Dialog Component For  Deletion all Confirmation*/}
                      <DialogComponent
                        width="400px"
                        animationSettings={this.settings}
                        header="Delete All"
                        showCloseIcon={true}
                        buttons={this.deleteAllButton}
                        ref={(dialog) => (this.dialogInstance = dialog)}
                        visible={this.state.hideDeleteAllPopup}
                        close={this.dialogClose}
                      >
                        <img
                          src="./assets/images/warn.svg"
                          style={{
                            paddingRight: "0px",
                            height: "20px",
                            width: "20px",
                          }}
                          content=""
                        />
                        &nbsp;Do you want to delete all the Project Website?
                        <br />
                        Note: Press 'Yes' to delete or press 'No' to decline.
                      </DialogComponent>

                      <DialogComponent
                        width="400px"
                        animationSettings={this.settings}
                        header="Incorrect Password"
                        showCloseIcon={true}
                        buttons={this.incorrectPasswordButtons}
                        ref={(dialog) => (this.dialogInstance = dialog)}
                        visible={this.state.hideIncorrectPassword}
                        close={this.IncorrectPassworddialogClose}
                      >
                        Please type "Delete"
                      </DialogComponent>

                      <DialogComponent
                        width="400px"
                        animationSettings={this.settings}
                        header="Delete Confirmation"
                        showCloseIcon={true}
                        buttons={this.textAreaConfir}
                        ref={(dialog) => (this.dialogInstance = dialog)}
                        visible={this.state.hideTextAreaPopup}
                        close={this.DeletedialogClose}
                      >
                        Please type "Delete" for confirmation
                        <input type="text" id="deleteInputFromUser" />
                      </DialogComponent>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default WebsiteReading;



// WEBPACK FOOTER //
// ./src/projectmgmt/faq/WebsiteReading.js